import React, { useContext } from 'react';
import * as R from 'ramda';
import Box from '@mui/material/Box';
import styles from './css/AllInvoices.scss';
import Card from '@mui/material/Card';
import { CardContent } from '@mui/material';
import { store } from '../store';
import LabelValueCD from '../../component/LabelValueCD';
import ClientIcon from '@mui/icons-material/BusinessOutlined';
import PhoneIcon from '@mui/icons-material/Phone';
import LocationIcon from '@mui/icons-material/LocationOn';
import useGetClient from './../fetch/useGetClient';
import { CenterProgress } from '../../component/CenterProgress';
import { Route, useHistory } from 'react-router-dom';
import CardCD from '../../component/CardCD';
import ClientInvoices from './ClientInvoices';
import CardCDTitle from './../../component/CardCDTitle';
import ProductList from './ProductList';
import { ROUTE_BASE } from './vars';
import { CardTitleCD } from '@cd/rhf';

const FINAL_ROUTE_BASE = `${ROUTE_BASE}/clients`;

const cardsStyle = {
	display: 'flex',
	flexWrap: 'wrap',
	padding: '8px',
	marginTop: '16px',
	marginBottom: '8px',
	'& > *': {
		width: '200px',
		marginRight: '8px',
		marginBottom: '8px'
	}
};

function getInvoices(data) {
	return (
		<Route
			path={`${FINAL_ROUTE_BASE}/:clientID/invoices/:verb`}
			render={props => (
				<CardCD title={<CardCDTitle title="INVOICES" />}>
					<ClientInvoices data={data} {...props} />
				</CardCD>
			)}
		/>
	);
}
function getCreateCharges(data) {
	return (
		<Route
			path={`${FINAL_ROUTE_BASE}/:clientID/charge/:type`}
			render={props => (
				<CardCD title={<CardCDTitle title="CHARGES" />}>
					<ProductList data={data} {...props} />
				</CardCD>
			)}
		/>
	);
}

const Client = ({ match }) => {
	const { dispatch } = useContext(store);
	const history = useHistory();
	const { clientID } = (match && match.params) || 0;
	const { isLoading, isError, data, error } = useGetClient(
		clientID,
		dispatch
	);

	if (isError) {
		return <div>{JSON.stringify(error)}</div>;
	}

	if (isLoading) {
		return <CenterProgress />;
	}
	if (!data || R.isEmpty(data)) {
		return <div>NO DATA</div>;
	}

	const { v1, v2, v3 } = data;

	return (
		<div className={styles.wrap}>
			<Card>
				<CardTitleCD
					css={{ pointer: 'cursor' }}
					title="CLIENT INFO"
					onClick={() => {
						history.goBack();
					}}
				/>
				<CardContent>
					<LabelValueCD label="CLIENT" value={v1} Icon={ClientIcon} />
					<LabelValueCD
						label="ADDRESS"
						value={v2}
						Icon={LocationIcon}
					/>
					<LabelValueCD label="PHONE" value={v3} Icon={PhoneIcon} />

					<Route
						path={`${FINAL_ROUTE_BASE}/:clientID`}
						exact
						render={props => (
							<Box component="div" sx={cardsStyle}>
								<CardCD
									title="INVOICES"
									okButtonTitle=""
									subtitle=""
									onClick={() =>
										history.push(
											`${FINAL_ROUTE_BASE}/${clientID}/invoices/outstanding`
										)
									}
									clickable>
									<span>Manage invoices</span>
								</CardCD>
								<CardCD
									title="SERVICES"
									okButtonTitle=""
									subtitle=""
									onClick={() =>
										history.push(
											`${FINAL_ROUTE_BASE}/${clientID}/charge/subscription`
										)
									}
									clickable>
									<span>Create charges </span>
								</CardCD>
								<CardCD
									title="ACCOUNTS"
									okButtonTitle="LOGIN"
									subtitle=""
									onClick={() => alert('yey')}
									clickable>
									<span>HELLO</span>
								</CardCD>
							</Box>
						)}
					/>
				</CardContent>
			</Card>
			{getInvoices(data)}
			{getCreateCharges(data)}
		</div>
	);
};

const RedirClient = () => (
	<Route
		path={`${FINAL_ROUTE_BASE}/:clientID`}
		render={props => <Client {...props} />}
	/>
);

export default RedirClient;
